import { client } from 'lib/axios'

const API_LOCKER_PLANS = `/v1/locker_plans`
export const getLockerPlans = () => client.get(API_LOCKER_PLANS)
